module.exports = __webpack_public_path__ + "static/assets/fc23fa4f0f18f351f731c3ea0c07c9e0.png";